/**
 * @generated SignedSource<<1b835dcf464a7883b53a3bab30e8525b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_displayInfo$data = {
  readonly pricing: {
    readonly showSold: boolean | null;
    readonly showUnavailable: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_displayInfo";
};
export type PdpRespSidebarBlurbs_displayInfo$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showUnavailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "2fdc3c9f176989c6082300b0d9cb6b4d";

export default node;
